export function getTrackingData() {
  const url = new URL(window.location.href);

  return {
    pageUrl: url.href,
    utm_source: url.searchParams.get("utm_source"),
    utm_medium: url.searchParams.get("utm_medium"),
    utm_campaign: url.searchParams.get("utm_campaign"),
    utm_term: url.searchParams.get("utm_term"),
    utm_content: url.searchParams.get("utm_content"),
    referrer: document.referrer,
    timestamp: new Date().toISOString(),
    deviceType: /mobile/i.test(navigator.userAgent)
      ? "mobile"
      : "desktop",
  };
}

// store UTM in localStorage
export function storeUTMParams() {
  const params = new URLSearchParams(window.location.search);

  const utmData = {
    utm_source: params.get("utm_source"),
    utm_medium: params.get("utm_medium"),
    utm_campaign: params.get("utm_campaign"),
    utm_term: params.get("utm_term"),
    utm_content: params.get("utm_content"),
  };

  localStorage.setItem("utmData", JSON.stringify(utmData));
}